import { hasValidSubscriptionEndCalendarDate } from '@shared/subscriptionEndDate'

export function resolvePlanChangeExpiry(
  form: { endMode: string; endsAt: string; durationDays: string },
  now = Date.now()
): string | null {
  let timestamp: number
  if (form.endMode === 'date') {
    const value = form.endsAt.trim()
    if (!hasValidSubscriptionEndCalendarDate(value)) return null
    timestamp = new Date(value).getTime()
  } else if (form.endMode === 'days' && /^\d+$/.test(form.durationDays.trim())) {
    const days = Number(form.durationDays)
    if (!Number.isSafeInteger(days) || days <= 0) return null
    timestamp = now + days * 24 * 60 * 60 * 1000
  } else {
    return null
  }
  const end = new Date(timestamp)
  if (!Number.isFinite(end.getTime()) || timestamp <= now || end.getUTCFullYear() > 9999) {
    return null
  }
  return end.toISOString()
}
